// src/components/join/JoinJoined.js
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useJoin } from './joinContext';

export default function JoinJoined() {
  const { team, teamId, isPrelaunchCommitteeMode } = useJoin();
  const navigate = useNavigate();

  useEffect(() => {
    if (teamId) navigate(`/teams/${teamId}`, { replace: true });
  }, [teamId, navigate]);

  return (
    <div className="text-center">
      <h2 className="text-2xl font-semibold mb-2">{isPrelaunchCommitteeMode ? 'Membership setup complete' : `Welcome to ${team?.name}!`}</h2>
      <p className="text-gray-700">{isPrelaunchCommitteeMode
        ? "You're ready for launch. Your member record and billing tenure will begin when the club goes live."
        : "You're now a member. Taking you to your club…"}</p>
      {teamId && <Link className="button button-primary" to={`/teams/${teamId}`}>Go to club</Link>}
    </div>
  );
}
